import React from 'react';
import ReactPDF, { Text } from '@react-pdf/renderer';
import { getFontFamily } from '../../utils';
import { FONT } from '../../../../types/enums';

interface Props {
  address: string;
  addressFontSize: number;
  styles: ReactPDF.Styles;
}

export const BadgeCountryName: React.FC<Props> = ({ address, addressFontSize, styles }) => {
  const getAddressStyles = () => {
    return { ...styles.address, fontSize: addressFontSize, ...getFontFamily(address, { fallbackFont: FONT.HELVETICA }) };
  };

  const addressStyles = getAddressStyles();
  return (
    <Text test-id={'country'} style={addressStyles}>
      {address}
    </Text>
  );
};
